import React from "react";
import { PlusCircle } from "react-feather";

export default ({ label, selected, creating, select, unselect }) => {
  let className = "tag";
  if (selected) {
    className += " selected-tag";
  }

  if (creating) {
    className += " creating-tag";
  }

  return (
    <div className={className} onClick={selected ? unselect : select}>
      {creating && <PlusCircle size={14} className="me-1" />}
      {label}
      {selected && <div className="remove-tag">{" X"}</div>}
    </div>
  );
};
